import React from 'react';
import withIcon from '../utilities/withIcon';

const IconChartBarHorz = () => {
  return (
    <g>
      <path d="M.75 0a.75.75 0 0 1 .75.75V2h5.546a.95.95 0 0 1 .944.84l.006.11V5.5h3.052a.95.95 0 0 1 .944.84l.006.11V9h3.052a.95.95 0 0 1 .944.84l.006.11v3.1a.95.95 0 0 1-.84.944l-.11.006H1.5v1.25a.75.75 0 0 1-.648.743L.75 16a.75.75 0 0 1-.75-.75V.75A.75.75 0 0 1 .648.007L.751 0zM14.5 10.5H1.75v2h12.748v-2zM10.497 7H1.751v2h8.746V7zM6.495 3.5H1.751v2h4.744v-2z" />
    </g>
  );
};

export default withIcon(IconChartBarHorz);
